module.exports = __webpack_public_path__ + "static/seguranca-tab-5c867cba2fc08fcb4b2b2c15c2f4ef72.png";